import { BuiltInValidatorProps, getBuiltInValidatorsByProps } from './FormBuiltInValidators'

export type FormValidator<V> = (formValue: V) => Record<string, string | string[]> | undefined

export type FieldValidator<V> = (fieldValue: V) => string | string[] | undefined

export const normalizeFormValidators = <V>(formValidate?: FormValidator<V> | FormValidator<V>[]) =>
  formValidate ? (formValidate instanceof Array ? formValidate : [formValidate]) : []

export const normalizeFieldValidators = <V>(
  fieldValidators?: FieldValidator<V> | FieldValidator<V>[],
) =>
  fieldValidators ? (fieldValidators instanceof Array ? fieldValidators : [fieldValidators]) : []

export const runFormValidators = <V>(
  validate: FormValidator<V> | FormValidator<V>[] | undefined,
  value: V,
) => {
  if (!validate) return {}

  const flags: Record<string, Set<string>> = {}
  const validators = normalizeFormValidators(validate)

  for (const validator of validators) {
    const newFlags = validator(value)
    if (!newFlags) continue

    for (const [fieldName, fieldFlag] of Object.entries(newFlags)) {
      if (!flags[fieldName]) flags[fieldName] = new Set()
      const fieldFlags = fieldFlag instanceof Array ? fieldFlag : [fieldFlag]
      for (const f of fieldFlags) flags[fieldName].add(f)
    }
  }

  return flags
}

export const runFieldValidators = <V>(
  props: BuiltInValidatorProps<V>,
  validate: FieldValidator<V> | FieldValidator<V>[] | undefined,
  value: V,
) => {
  const flags = new Set<string>()
  const validators = normalizeFieldValidators(validate)

  for (const validator of [...validators, ...getBuiltInValidatorsByProps(value, props)]) {
    const newFlags = validator(value)
    if (!newFlags) continue

    const fieldFlags = newFlags instanceof Array ? newFlags : [newFlags]
    for (const fieldFlag of fieldFlags) flags.add(fieldFlag)
  }

  return flags
}
